import { render } from "./LayoutSiteOpen.vue?vue&type=template&id=2998b57c&lang=pug"
import script from "./LayoutSiteOpen.vue?vue&type=script&lang=js"
export * from "./LayoutSiteOpen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__